export const environment = {
  production: false,
  api_server: 'https://api.tqr.la',
  // Sin barra final: todos los consumidores concatenan `${ecommerceDomain}/...`.
  ecommerceDomain: 'https://qa.eventos.tqr.la',
  /** Portal web al que entran los vendedores con sus credenciales. */
  webAppUrl: 'https://dev.app.tqr.la',
  /** CMS (dashboard) donde se administran las campañas push. */
  // TODO(EP-069): placeholder, se usa el CMS de produccion; reemplazar por la URL del CMS de dev/QA si existe.
  cmsUrl: 'https://cms.tqr.la',
  websocket: {
    host: 'dev.ws.tqr.la',
    port: 443,
    scheme: 'http',
    appId: 'turnstile-app',
    key: 'turnstile-key',
    secret: 'turnstile-secret',
    forceTLS: true,
  },
};
